/*
 * File: ui-validate-email.ts
 * File Created: 2024-09-12 07:45:54
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 09:28:11
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    EUITagRuleUnion,
} from "../core";

// @uiValidateEmail - validate email regexp.
// allow value: null | IUIValidateEmail
// default as: defaultData

interface IUIValidateEmail {
    "text-error": string;
}
const defaultData: IUIValidateEmail = {
    "text-error": "w_RequireValidEmailFormat",
};
const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
const regex_gradual = /^(?!@)[\w-\.]*@?([\w-]*\.?)*[\w-]{0,4}$/;

@UITag.set()
export class uiValidateEmail extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Object];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule: any = this.parseRule(input) ?? defaultData;
        /// generize to object
        let ro: IUIValidateEmail = {
            ...defaultData,
            ...rule,
        };

        let moreTags: IUITagMoreTagsUnit[] = [];
        const { element } = input.variables ?? {};

        moreTags.push({
            tag: "uiValidator",
            rule: (o) =>
                regex.test(o.value)
                    ? undefined
                    : { state: false, message: element?.$_(ro["text-error"]) },
        });
        return {
            specials: {
                moreTags,
            },
        };
    }
}
